import { Box, Text } from "@chakra-ui/react";
import { Testimonial } from "./Testimonials";
import CallToAction from "./CallToAction";

export default function TestimonialsPage() {
  return (
    <Box marginBottom={8} display="flex" justifyContent="center" alignItems="center">
      <Box m={8} mt={8} width={{ base: "100%", md: "80%" }} maxW={"3xl"}>
        <Text fontSize="3xl" mb={12} textAlign="center">Loved by JetBrains developers</Text>
        <Box 
          display="grid"
          gridTemplateColumns={{ 
            base: "1fr",           // 1x4 on mobile (single column)
            md: "1fr 1fr"          // 2x2 on desktop (two columns)
          }}
          gap={{ base: 4, md: 4 }}  // No gap on desktop
          justifyItems="stretch"   // Changed from center to stretch
        >
          <Testimonial name="Josiah Parappally" company="Tech Lead, Ramp" _href="" face={require("../assets/users/josiah.jpeg")}>
          Next-edit autocomplete in PyCharm is an absolute game changer.<br/>I usually have to choose between powerful IDEs and smart suggestions - but with Sweep, I get both. <b>It’s a massive productivity boost.</b>
          </Testimonial>
          <Testimonial name="Remy Royer-Adnot" company="Lead Developer, Audience Republic" _href="" face={require("../assets/users/remy.png")}>
          I've been using Sweep intensively the past three months. It was really helpful. I've achieved <b>three weeks of work in two days</b>.
          </Testimonial>
          <Testimonial name="Chuck Greb" company="Director of Engineering (Android)" _href="" face={require("../assets/users/chuck.png")}>
          The code suggestions I get from Sweep Agent <b>are consistently better</b> than other similar tools. <br/> I enjoy working with Sweep more than other IDE plugins and it's also very memory efficient inside of Android Studio.
          </Testimonial>
          <Testimonial name="Anonymous" company="Developer, 10B+ FinTech" _href="" face="">
          It's been so nice to be back in JetBrains without having to feel like I'm missing out on good autocomplete.
          </Testimonial>
        </Box>
        <Box pt={12}>
        <CallToAction showHeader={false} />
        </Box>
      </Box>
    </Box>
  );
}